<script>
    export default {
        components: {},

        props: [],

        mixins: [],

        data: function () {
            return {
                loading: false,

                // This value keeps track of how recently the Query value has been changed
                // This in turn helps prevent frequent API calls
                lastQuery: 0,
                queryIndex: [],

                error: {
                    message: '',
                },
            };
        },

        computed: {
            //
        },

        created() {
            //
        },

        mounted() {
            //
        },

        methods: {
            /**
             * Use this method to only dispatch an action after X amount of seconds
             * Meant to be used for example with reloading / searching. If a user hasn't input something after
             * 300ms, it will fire the action
             *
             * @param action_name
             * @param payload
             * @param wait_time
             * @returns {Promise<unknown>}
             */
            dispatchThrottled(action_name, payload, wait_time = 300) {
                this.lastQuery = this.lastQuery + 1;
                let currentQuery = this.lastQuery;
                let vm = this;
                this.resetErrors();

                // Keep track of the latest query
                this.queryIndex.push(this.lastQuery);

                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        // When the last query is equal to this one, we fire it off.
                        if (vm.queryIndex[vm.queryIndex.length - 1] === currentQuery) {
                            // Show a loader if required
                            vm.loading = vm.show_loader;

                            vm.$store.dispatch(action_name, payload).then((response) => {
                                // Need both catch() and then() for IE11
                                vm.loading = false;
                                resolve(response);
                            }).catch((error) => {
                                // Need both catch() and then() for IE11
                                vm.loading = false;
                                reject(error);

                                vm.error = error.data;
                            });
                        }
                    }, wait_time);
                });
            },
            resetErrors() {
                this.error = {
                    message: ''
                };
            }
        },

        watch: {
            //
        }
    };
</script>
